import { Component, OnInit } from '@angular/core';  
@Component({
  selector: 'allReportsMain',
  templateUrl: './allReportsMain.component.html', 
})
export class allReportsMainComponent implements OnInit {
   
  constructor() { }

  ngOnInit(){  
  }
}



// WEBPACK FOOTER //
// ./src/app/AllReports/allReportsMain.component.ts